import { useEffect } from 'react';
import { useEmpresa, EMPRESA_ID_MAP_REVERSE } from '@/contexts/EmpresaContext';
import { useBackofficeAuth } from '@/contexts/BackofficeAuthContext';

export default function EmpresaAuthBridge() {
  const { definirEmpresasPermitidas } = useEmpresa();
  const { session, empresasDoUsuario } = useBackofficeAuth();

  useEffect(() => {
    if (session.isAuthenticated && empresasDoUsuario.length > 0) {
      // Converter empresaBackofficeId (EMP-001) → empresaId numérico (1)
      const idsNumericos = empresasDoUsuario
        .map(eu => EMPRESA_ID_MAP_REVERSE[eu.empresaId])
        .filter((id): id is number => id !== undefined);

      console.log('🔗 Bridge: definindo empresas permitidas para', session.nome, idsNumericos);
      definirEmpresasPermitidas(idsNumericos);
    } else if (!session.isAuthenticated) {
      // Sem sessão = sem filtro (mostra todas as empresas)
      console.log('🔗 Bridge: sem sessão, resetando filtro');
      definirEmpresasPermitidas(null);
    }
  }, [session.isAuthenticated, session.userId, empresasDoUsuario]);

  return null;
}